import {
  AUTH_STATE_CHANGED,
  USER_DATA_INIT,
  AUTH_INIT,
  CLEAR_USER_AUTH,
  GET_EMPRESA_INIT,
  GET_EMPRESA_SUCCESS,
  SET_EMPRESA,
  AUTH_ERROR_MSG,
  GET_PAINEIS_EMPRESA_INIT,
  GET_PAINEIS_EMPRESA_SUCCESS,
  CLEAR_LIST_PAINEIS_EMP,
  GET_PAINEIS_USUARIO_INIT,
  GET_PAINEIS_USUARIO_SUCCESS
} from '../actionTypes';
import { mapEmpresaParaMyEmp } from './mappers';

const INIT_STATE = {
  isAuthenticated: false,
  isInitialised: false,
  loading: false,
  user: null,
  userPrivileges: {},
  myEmp: {},
  paineisEmpresaAtual: [],
  empId: '',
  msg: '',
  isReceived: false,
  error: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case AUTH_STATE_CHANGED: {
      const { isAuthenticated, user, loading, userPrivileges } = action.payload;
      if (user?.myEmp?.id) {
        sessionStorage.setItem('selectedEmpresaId', user.myEmp.id);
      }
      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        loading,
        user: user,
        userPrivileges,
        myEmp: user?.myEmp
      };
    }
    case AUTH_INIT:
      return { ...state, loading: true, error: false };
    case USER_DATA_INIT:
      return { ...state, loading: true, dataRequested: true, error: false };
    case GET_EMPRESA_INIT: {
      const { empId } = action.payload;
      return {
        ...state,
        loading: true,
        isReceived: false,
        empId
      };
    }
    case GET_EMPRESA_SUCCESS: {
      const { myEmp } = action.payload;
      if (myEmp && myEmp.id) {
        sessionStorage.setItem('selectedEmpresaId', myEmp.id);
      }
      return {
        ...state,
        loading: false,
        isReceived: true,
        error: false,
        user: {
          ...state.user,
          myEmp: myEmp
        },
        myEmp: myEmp
      };
    }
    case AUTH_ERROR_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        error: true,
        msg: msg
      };
    }
    case SET_EMPRESA: {
      const { empresa } = action.payload;
      if (empresa && empresa.id) {
        sessionStorage.setItem('selectedEmpresaId', empresa.id);
      }
      return {
        ...state,
        myEmp: mapEmpresaParaMyEmp(empresa)
      };
    }
    case GET_PAINEIS_EMPRESA_INIT:
      return { ...state, loading: true, error: false };

    case GET_PAINEIS_EMPRESA_SUCCESS: {
      const { paineisEmpresaAtual, msg, isError } = action.payload;

      return {
        ...state,
        paineisEmpresaAtual,
        loading: false,
        error: isError,
        msg
      };
    }
    case CLEAR_USER_AUTH: {
      sessionStorage.removeItem('selectedEmpresaId');
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        isInitialised: true,
        user: null,
        permissionsUserType: [],
        myEmp: {},
        empId: '',
        isReceived: false,
        error: false,
        paineisEmpresaAtual: []
      };
    }
    case CLEAR_LIST_PAINEIS_EMP:
      return {
        ...state,
        paineisEmpresaAtual: []
      };
    case GET_PAINEIS_USUARIO_INIT:
      return { ...state };
    case GET_PAINEIS_USUARIO_SUCCESS: {
      const { paineis } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          paineis
        }
      };
    }
    default:
      return { ...state };
  }
};
